import { render, staticRenderFns } from "./SendEditDialog.vue?vue&type=template&id=33c49f70&scoped=true"
import script from "./SendEditDialog.vue?vue&type=script&lang=js"
export * from "./SendEditDialog.vue?vue&type=script&lang=js"
import style0 from "./SendEditDialog.vue?vue&type=style&index=0&id=33c49f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c49f70",
  null
  
)

export default component.exports